import { render, staticRenderFns } from "./AppResultListFix.vue?vue&type=template&id=1c7af1fc"
import script from "./AppResultListFix.vue?vue&type=script&lang=js"
export * from "./AppResultListFix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports